// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6i-0";
export var startPickingButton = "_6i-1";